// JsFromRoutes CacheKey 4c43e4efdeaa6eba0d1f5adc0ede7161
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  resend: /* #__PURE__ */ definePathHelper('post', '/confirm-phone-expired/resend'),
  confirm: /* #__PURE__ */ definePathHelper('post', '/confirm-phone/confirm'),
}
